import React, { Component } from 'react';
import { loadCaptchaEnginge, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import Button from './components/button';
import TextBox from './components/textbox'
import IconButton from '@material-ui/core/IconButton';
import CachedIcon from '@material-ui/icons/Cached';
 
class SimpleCaptcha extends Component {
    state = {
        captchaTextVal: false
    }
 
   componentDidMount () {
      loadCaptchaEnginge(6); 
   };
 
   doSubmit = () => {
       let user_captcha = document.getElementById('user_captcha_input').value;
 
       if (validateCaptcha(user_captcha)==true) {
           loadCaptchaEnginge(6); 
           this.props.handleToUpdateNumber();
           document.getElementById('user_captcha_input').value = "";
       }
 
       else {
           document.getElementById('user_captcha_input').value = "";
       }
   };

   doRefresh = () => {
    let user_captcha = document.getElementById('user_captcha_input').value;
 
    if (validateCaptcha(user_captcha)==true) {
        loadCaptchaEnginge(6); 
        document.getElementById('user_captcha_input').value = "";
        this.setState({captchaTextVal: false})
    }
    else {
        document.getElementById('user_captcha_input').value = "";
        this.setState({captchaTextVal: false})
    }
   }

   handleToUpdateContent = () => {
    let user_captcha = document.getElementById('user_captcha_input').value;
    if (validateCaptcha(user_captcha, false)==true) {
        this.setState({captchaTextVal: true})
    }
    else {
        this.setState({captchaTextVal: false})
    }
   }
 
   render() {
    const { captchaTextVal } = this.state;
       return (<div>
           <div className="container validate__captcha__paytm">
               <div className="form-group">
 
                   <div className="col mt-3">
                       <div className="captcha_with_icon">
                        <LoadCanvasTemplateNoReload />
                        <IconButton 
                                disabled={false}
                                onClick={() => this.doRefresh()}
                            >
                                <CachedIcon />
                            </IconButton>
                        </div>
                   </div>
                   <TextBox className='textBox'
                                name="user_captcha_input"
                                label={'user_captcha_input'}
                                placeholder={'Enter Captcha Value'}
                                handleToUpdate={this.handleToUpdateContent}
                        />
 
                   <Button label= {'Enter registered contact number'} 
                                name={'VERIFY NUMBER'} 
                                visible={true}
                                disabled={captchaTextVal == false ? true : false}
                                handleToUpdate={() => this.doSubmit()}  />
               </div>
 
           </div>
       </div>);
   };
}
 
export default SimpleCaptcha;